<template>
  <div>
    <el-dialog :title="text+'教师'"
               :visible.sync="dialogVisible"
               v-dialogDrag
               :close-on-click-modal="false"
               :append-to-body="true"
               width="400px"
               :before-close="handleClose">
      <el-form :model="form"
               :rules="rules"
               ref="formRef"
               label-width="60px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="年级"
                          prop="grade_id">
              <el-select v-model="form.grade_id"
                         style="width:100%"
                         @change="change"
                         placeholder="请选择">
                <el-option v-for="item in gradeList"
                           :key="item.grade_id"
                           :label="item.grade_name"
                           :value="item.grade_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="科目"
                          prop="subject_id">
              <el-select v-model="form.subject_id"
                         style="width:100%"
                         placeholder="请选择">
                <el-option v-for="item in subjectList"
                           :key="item.subject_id"
                           :label="item.subject_name"
                           :value="item.subject_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="模式"
                          prop="mode_id">
              <el-select v-model="form.mode_id"
                         style="width:100%"
                         placeholder="请选择">
                <el-option v-for="item in modeList"
                           :key="item.id"
                           :label="item.mode_name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="教师">
              <el-select v-model="form.teachers"
                         style="width:100%"
                         multiple
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in teacherList"
                           :key="item.edu_user_id"
                           :label="item.edu_user_name"
                           :value="item.edu_user_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="save">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      form: {},
      subjectList: [],
      teacherList: [],
      gradeList: [],
      text: '',
      modeList: [],
      rules: {
        edu_user_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        subject_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        mode_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        grade_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
  },
  mounted () {
    this.getTeacherList()
    this.getGradeList()
  },
  methods: {
    change () {
      this.modeList = []
      this.form.mode_id = ''
      this.subjectList = []
      this.form.subject_id = ''
      if (this.form.grade_id == '') return
      this.getMode()
    },
    getMode () {
      this.getSubjectList()
      this.$http({
        url: '/api/v1/public/grade_mode',
        method: 'get',
        params: {
          grade_id: this.form.grade_id
        }
      }).then(res => {
        this.modeList = res.data
      })
    },
    getGradeList () {
      this.$http({
        url: '/api/v1/school/select_grade',
        method: 'get',
      }).then(res => {
        this.gradeList = res.data.list
      })
    },
    getTeacherList () {
      this.$http({
        url: '/api/v1/school/same_teacher',
        method: 'get',
      }).then(res => {
        this.teacherList = res.data
      })

    },
    getSubjectList () {

      this.$http({
        url: '/api/v1/school/get_subject',
        method: 'get',
        params: {
          grade_id: this.form.grade_id
        }
      }).then(res => {
        this.subjectList = res.data.list
      })
    },
    handleClose () {
      this.$refs.formRef.resetFields()
      this.dialogVisible = false
    },
    save () {
      this.$refs.formRef.validate(val => {
        if (!val) return
        this.$http({
          url: '/api/v1/special/class_subject_add',
          method: 'post',
          data: this.form
        }).then(res => {
          this.$notify({
            title: '提示',
            message: '操作成功!',
            type: 'success'
          });
          this.$parent.refresh()
          this.handleClose()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 20px;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4px;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.toopic {
  font-size: 12px;
  line-height: 14px;
  span {
    margin-left: -12px;
    display: inline-block;
    width: 100%;
    width: 305px;
    color: #ff8383;
    transform: scale(0.9);
  }
}

::v-deep .el-dialog {
  border-radius: 15px;
}
.el-tabs {
  margin-left: 20px;
}
::v-deep .el-tabs__nav-wrap::after {
  background: none;
}
.warp {
  display: flex;
  margin-top: 20px;
  div {
    &:nth-child(1) {
      flex: 1;
      margin-left: 8px;
    }
    &:nth-child(2) {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>